
import logoImage from "../../assets/logo/logo.svg";
import logoText from "../../assets/logo/text.svg";

const AuthHeader = () => (
  <div className="mb-9 flex flex-col items-center">
    <img src={logoImage} alt="Supreme Edits Logo" className="w-20 h-14" />
    <img src={logoText} alt="Supreme Edits" className="w-48 mt-2" />
  </div>
);

export default AuthHeader;